import PieChart from "../Charts/PieChart";

const DashboardAmountAndTypeCharts = ({ dashBoardSummary, loading }) => {
    return (
        <div className="row">
            {/* <div className="col-md-6">
                <h3 className="text-center my-5">
                    Monto por tipo de pedido
                </h3>
                {
                    dashBoardSummary?.ordersAmountByType && Object.keys(dashBoardSummary?.ordersAmountByType).length > 0 && !loading ?
                        <PieChart
                            label="valueAndPercent"
                            labelStartAdornment='$'
                            labels={['Mensual', 'Extraordinario', 'Manual']}
                            defaultSeries={Object.keys(dashBoardSummary?.ordersAmountByType).map((key2) => dashBoardSummary?.ordersAmountByType[key2] ? Number(dashBoardSummary?.ordersAmountByType[key2]) : 0)}
                            colors={['#34b4db', '#df6adb', '#5e74f4']}
                        />
                        :
                        <h3 className="text-center text-danger">
                            No hay datos para mostrar.
                        </h3>
                }
            </div> */}
            {/* <div className="col-md-6">
                <h3 className="text-center my-5">
                    Porcentaje tipo de pedido
                </h3>
                {
                    dashBoardSummary?.ordersCountByType && Object.keys(dashBoardSummary?.ordersCountByType).length > 0 && !loading ?
                        <PieChart
                            labels={['Extraordinario', 'Manual', 'Mensual']}
                            defaultSeries={[
                                dashBoardSummary?.ordersCountByType?.extraordinary || 0,
                                dashBoardSummary?.ordersCountByType?.manual || 0,
                                dashBoardSummary?.ordersCountByType?.monthly || 0
                            ]}
                            colors={['#df6adb', '#5e74f4', '#34b4db']}
                        />
                        :
                        <h3 className="text-center text-danger">
                            No hay datos para mostrar.
                        </h3>
                }
            </div> */}
        </div>
    );
};

export default DashboardAmountAndTypeCharts;
